module.exports = __webpack_public_path__ + "static/media/16.b2c2601b.jpg";